import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import * as Admin from 'src/replicant/admin';
import StateObserver from 'src/StateObserver';
import { createLaunchSequence, actionBlock } from './LaunchSequence';
import { GCInstant as platform } from 'src/lib/gcinstant';
import { openSuperLollipop } from '../superLollipop/superLollipop.sequence';
import { setCompensation } from '../inventory/inventory.redux';
import { animatePuzzleRewards } from '../animation/rewardAnimation';
import type { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';

export const adminLaunchSequence = createLaunchSequence([
  /**
   * Show admin messages
   */
  actionBlock({
    skip: ({ user }) => !Admin.getters.hasUnclaimedMessages(user),
    actions: [
      async () => {
        // Hide loading screen, so the popups can be shown.
        await platform.dismissLoadingScreenAsync({
          launchPath: 'admin_messages',
        });

        const { user } = StateObserver.getState();
        const reimbursements = Admin.getters.getUnclaimedMessagesPopupData(
          user,
          StateObserver.now(),
        );

        if (reimbursements.newPetName) {
          await openPopupPromise('popupAdminRename', { ...reimbursements });
        }

        if (reimbursements.coins || reimbursements.gems) {
          await openPopupPromise('popupAdminReimburse', {
            coins: reimbursements.coins,
            gems: reimbursements.gems,
          });

          // Build rewards and set compensation to freeze header display
          const rewards: Match2Reward[] = [];
          if (reimbursements.coins) {
            rewards.push({ type: 'bPoints', amount: reimbursements.coins });
            StateObserver.dispatch(
              setCompensation({ bPoints: reimbursements.coins }),
            );
          }
          if (reimbursements.gems) {
            rewards.push({ type: 'gems', amount: reimbursements.gems });
            StateObserver.dispatch(
              setCompensation({ gems: reimbursements.gems }),
            );
          }

          // Claim resources (state updates, but header is offset by compensation)
          await StateObserver.invoke.claimAdminMessageResources();

          // Animate rewards — compensate handles per-icon onLand and safety clear
          await animatePuzzleRewards({ rewards, compensate: true });
        } else {
          // No coins/gems reimbursement, claim resources directly
          await StateObserver.invoke.claimAdminMessageResources();
        }

        if (reimbursements.match2Rewards.length) {
          await openPopupPromise('popupMatch2GrantRewards', {
            rewards: reimbursements.match2Rewards,
          });
        }

        // The super lollipop streak should be presented after the claim resources action
        if (reimbursements.superLollipopStreak > 0) {
          await openSuperLollipop({ originFeature: 'admin' });
        }

        // Continue with next action.
        return false;
      },
    ],
  }),
]);
